import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorPickerCardComponent } from './color-picker-card.component';
import { MaterialModule } from '../../material/material.module';
import { ColorsModule } from '../colors.module';


@NgModule({
  declarations: [
    ColorPickerCardComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ColorsModule
  ],
  exports: [ColorPickerCardComponent]
})
export class ColorPickerCardModule { }
